module.exports = __webpack_public_path__ + "img/22.52cde4f9.png";